/**
 * Cognito Sync API
 *
 * Client-side wrappers for the /users/sync-cognito endpoints.
 */

import axiosClient from "./axiosClient";

export interface SyncErrorDetail {
	cognito_sub: string;
	email?: string;
	operation: "create" | "update" | "stale";
	error: string;
}

export interface SyncResult {
	created: number;
	updated: number;
	stale: number;
	errors: number;
	errors_detail: SyncErrorDetail[];
	started_at: string;
	completed_at: string;
}

export interface SyncMeta extends SyncResult {
	last_sync_at: string;
	last_sync_started_at: string;
	triggered_by_sub: string;
	triggered_by_email: string;
}

/** Trigger a full Cognito→Couchbase user sync. Admin only. */
export async function triggerCognitoSync(): Promise<SyncResult> {
	return axiosClient.post("/api/users/cognito-syncs");
}

/** Get metadata from the last completed sync, or null if never synced. */
export async function getSyncStatus(): Promise<SyncMeta | null> {
	return axiosClient.get("/api/users/cognito-syncs/status");
}
